import type { FaireCollectionEntity } from "../../entity_types/collection";

export const defaultCollection: FaireCollectionEntity = {
  token: "default",
  type: "collection",
  name: "Default Collection",
  productTokens: ["default"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "default-entity",
  },
};
